import { useQuery } from '@tanstack/vue-query';
import { novuService } from '@/services/novu.service';

export const useNovuCredentials = () => {
  return useQuery({
    queryKey: ['novu-credentials'],
    queryFn: () => {
      return novuService.getCredentials();
    },
  });
};
